export default function PortfolioSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            制作実績
          </h2>
        </div>

        {/* Portfolio Item */}
        <div className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-200 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Screenshot */}
            <div className="order-2 lg:order-1">
              <div className="bg-slate-800 rounded-xl p-3 shadow-2xl">
                {/* Browser Chrome */}
                <div className="bg-slate-700 rounded-t-lg px-4 py-2 flex items-center gap-2 mb-2">
                  <div className="flex gap-1.5">
                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                    <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                    <div className="w-3 h-3 rounded-full bg-green-500"></div>
                  </div>
                  <div className="flex-1 bg-slate-600 rounded px-3 py-1 text-xs text-slate-300">
                    meduse.co.jp
                  </div>
                </div>
                {/* Screenshot Image */}
                <div className="bg-white rounded-lg overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/a547e5108220e49fc6552e81382cf2b5/61b304d92443f67ae4306dbd08657adf.png"
                    alt="多機能型事業所やどかり"
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </div>

            {/* Details */}
            <div className="order-1 lg:order-2">
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-cyan-600 font-semibold mb-1">クライアント</p>
                  <p className="text-2xl font-bold text-slate-800">株式会社MEDUSE</p>
                </div>
                <div>
                  <p className="text-sm text-cyan-600 font-semibold mb-1">サイト名</p>
                  <p className="text-xl font-bold text-slate-800">多機能型事業所やどかり</p>
                </div>
                <div>
                  <p className="text-sm text-cyan-600 font-semibold mb-1">URL</p>
                  <a 
                    href="https://meduse.co.jp/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-lg text-cyan-600 hover:text-cyan-700 underline cursor-pointer"
                  >
                    https://meduse.co.jp/
                  </a>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-cyan-600 font-semibold mb-1">業種</p>
                    <p className="text-lg text-slate-700">福祉施設</p>
                  </div>
                  <div>
                    <p className="text-sm text-cyan-600 font-semibold mb-1">種別</p>
                    <p className="text-lg text-slate-700">コーポレートサイト</p>
                  </div>
                </div>
                <div>
                  <p className="text-sm text-cyan-600 font-semibold mb-1">制作期間</p>
                  <p className="text-lg text-slate-700">約1週間</p>
                </div>
                <div>
                  <p className="text-sm text-cyan-600 font-semibold mb-2">特徴</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-cyan-100 text-cyan-700 rounded-full text-sm font-semibold whitespace-nowrap">レスポンシブ対応</span>
                    <span className="px-3 py-1 bg-cyan-100 text-cyan-700 rounded-full text-sm font-semibold whitespace-nowrap">お問い合わせフォーム</span>
                    <span className="px-3 py-1 bg-cyan-100 text-cyan-700 rounded-full text-sm font-semibold whitespace-nowrap">アクセスマップ</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}